export default "__VITE_ASSET__BG94AeL6__"